<template>
    <SupplierDetailCard class="summary" :title="title" :description="description">
        <template #content>
            <template v-for="(n, i) in data">
                <div class="row data-row no-gutters" :key="i" v-if="n.isVisible === undefined || n.isVisible(n)">
                    <div class="col col-6 text-start">
                        <slot :name="'label(' + i + ')'" v-bind="n">{{ n.label }}</slot>
                    </div>
                    <div class="col col-6 text-end numeric">
                        <slot :name="'value(' + i + ')'" v-bind="n">{{ n.value }}</slot>
                    </div>
                </div>
            </template>
        </template>
    </SupplierDetailCard>
</template>

<script>
import SupplierDetailCard from "@/components/SupplierDetailCard.vue";

export default {
    props: {
        title: { type: String },
        description: { type: String },
        data: { type: [Object, Array] }
    },
    components: { SupplierDetailCard }
};
</script>

<style lang="scss" scoped>
@use "@/scss/custom";
.summary {
    .data-row {
        font-size: 14px;
        color: custom.$body-color;

        & > .col {
            padding-bottom: 8px;
            padding-top: 8px;
        }

        &:not(:last-of-type) .col {
            border-bottom: 1px solid custom.$dark;
        }
    }
}
</style>
